export default {
  get_quote: {
    title: "What is your current situation?"
  }
}



// WEBPACK FOOTER //
// ./src/i18n/translations/en/get-quote.js